<template>
	<div class="home__nav2">
		<div class="home__container nav">
			<!--<router-link
					:to="{ name: 'home'}"
					class="home__nav2__logo">
				<a href="http://www.bonelldoriga.com">
					<img src="../assets/img/bt_logo_tr.png" alt="BONELL+DORIGA" style="width: auto; height: 2rem;"/>
				</a>
				<span>BONELL+DORIGA</span>
			</router-link>-->
			<div></div>
			<div>

				<div class="dropdown">
					<router-link :to="{ name: 'services'}">
						<button class="dropbtn">{{ $t('Services') }}</button>
					</router-link>
					<div class="dropdown-content">
						<router-link :to="{ name: 'services'}">
							<span>{{ $t('Services') }}</span>
						</router-link>
					</div>
				</div>

				<div class="dropdown">
					<router-link :to="{ name: 'pricing'}">
						<button class="dropbtn">{{ $t('Pricing') }}</button>
					</router-link>
					<div class="dropdown-content">
						<router-link :to="{ name: 'pricing'}">
							<span>{{ $t('Pricing') }}</span>
						</router-link>
						<router-link :to="{ name: 'quote-request'}">
							<span>{{ $t('Quote_request') }}</span>
						</router-link>
					</div>
				</div>


				<div class="dropdown">
					<router-link :to="{ name: 'about'}">
						<button class="dropbtn">{{ $t('The_company') }}</button>
					</router-link>
					<div class="dropdown-content">
						<router-link :to="{ name: 'about'}">
							<span>{{ $t('About_us') }}</span>
						</router-link>
						<router-link :to="{ name: 'our-clients'}">
							<span>{{ $t('Our_clients') }}</span>
						</router-link>
						<router-link :to="{ name: 'philosophy'}">
							<span>{{ $t('Philosophy') }}</span>
						</router-link>
						<router-link :to="{ name: 'customer-service'}">
							<span>{{ $t('Customer_Service') }}</span>
						</router-link>
					</div>
				</div>

				<div class="dropdown">
					<router-link :to="{ name: 'contact'}">
						<button class="dropbtn">{{ $t('Contact') }}</button>
					</router-link>
					<div class="dropdown-content">
						<router-link :to="{ name: 'contact'}">
							<span>{{ $t('Contact') }}</span>
						</router-link>
					</div>
				</div>

				<div class="dropdown">
					<button class="dropbtn">{{ $t('Language') }}</button>
					<div class="dropdown-content">
						<a href="#" @click="setLanguage('ca')">Català</a>
						<a href="#" @click="setLanguage('es')">Castellano</a>
						<a href="#" @click="setLanguage('en')">English</a>
					</div>
				</div>
				<!--
				<router-link
						:to="{ name: 'login'}"
						class="home__nav__button">
					<span>{{ $t('Log_In') }}</span>
				</router-link>
				-->
			</div>
		</div>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import router from '../router'
    import { localStorageMixin } from '../mixins'

    export default {
        name: 'nav-bar',

        mixins: [localStorageMixin],

        computed: {
            ...mapGetters([
                'user'])
        },

        methods: {
            ...mapActions([
                'UPDATE_LANGUAGE',
                'SIGN_UP_USER',
                'INIT_NOTES'
            ]),

            onLogIn () {
                this.$router.push({name: 'login'})
            },
            setLanguage (data) {
                this.UPDATE_LANGUAGE(data)
                    .then(() => {
                        console.log(data)
                    })
                    .catch((error) => {
                        this.error = error.message
                    })
            }

        },

        head: {
            title: {
                inner: 'Barnatasa'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// NavBar.vue?7a4ce264